import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { observer, inject } from 'mobx-react';
import { Inspector } from 'react-dev-inspector';
import * as Sentry from '@sentry/react';
import en_US from 'antd/lib/locale/en_US';
import zh_CN from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
import Container from '@/router';
import locales from '@/locales';
import commonLocales from '&/locales';
import { enUSStr, zhCNStr } from '@/constants';
import LoadingComponent from '&/components/LoadingComponent';
const merge = require('lodash/merge');

export default inject('appStore')(
    observer(function App(props) {
        let { appStore } = props;
        let antdLocales = {
            [enUSStr]: en_US,
            [zhCNStr]: zh_CN,
        };

        if (window.location.href.includes('zxtest=1')) {
            let flag = new Date().getTime();
            Sentry.withScope(function (scope) {
                scope.setFingerprint(['{{ default }}', 'zxtest-11-12-', flag]);
                Sentry.captureException(new Error('zxtest-11-12-' + flag));
            });
            // throw new Error('zxtest-11-12'+ new Date().getTime());
        }

        initI18(appStore);

        const content = (
            <ConfigProvider locale={antdLocales[appStore.lang]}>
                <LoadingComponent>
                    <Container />
                </LoadingComponent>
            </ConfigProvider>
        );

        useEffect(() => {
            if (window.location.host === 'www.foxithd.com') {
                return;
            }

            try {
                new window.VConsole();

                // Set a timeout to wait for VConsole to render 天机移动事件，否则可能挡住页面中的按钮
                setTimeout(() => {
                    const vcSwitch = document.querySelector('.vc-switch');
                    if (vcSwitch) {
                        makeDraggable(vcSwitch);
                    }
                }, 500);
            } catch (error) {
                console.log('vvvv', error);
            }
        }, []);

        function makeDraggable(element) {
            let isDragging = false;
            let offsetX, offsetY;

            // Ensure the element has absolute positioning to be draggable
            element.style.position = 'fixed';

            element.addEventListener('mousedown', e => {
                isDragging = true;

                const rect = element.getBoundingClientRect();
                offsetX = e.clientX - rect.left;
                offsetY = e.clientY - rect.top;

                element.style.cursor = 'grabbing';

                // Prevent text selection while dragging
                e.preventDefault();
            });

            document.addEventListener('mousemove', e => {
                if (!isDragging) return;

                let newX = e.clientX - offsetX;
                let newY = e.clientY - offsetY;

                // Constrain movement within the window
                const winWidth = window.innerWidth;
                const winHeight = window.innerHeight;
                const elWidth = element.offsetWidth;
                const elHeight = element.offsetHeight;

                if (newX < 0) newX = 0;
                if (newY < 0) newY = 0;
                if (newX + elWidth > winWidth) newX = winWidth - elWidth;
                if (newY + elHeight > winHeight) newY = winHeight - elHeight;

                element.style.left = `${newX}px`;
                element.style.top = `${newY}px`;
                // VConsole's default styles might use right/bottom, so we clear them
                element.style.right = 'auto';
                element.style.bottom = 'auto';
            });

            document.addEventListener('mouseup', () => {
                if (isDragging) {
                    isDragging = false;
                    element.style.cursor = 'grab';
                }
            });
        }

        // 页面聚焦后，同时按住键盘qwe按键，就可以在页面选取要查看的组件了。选取好后点击，就会自动打开VS Code 定位到该组件的文件
        const app =
            process.env.NODE_ENV === 'development' ? (
                <Inspector keys={['q', 'w', 'e']}>{content}</Inspector>
            ) : (
                content
            );

        return app;
    })
);

function initI18(appStore) {
    let { lang } = appStore;

    //intl

    intl.init({
        currentLocale: lang, // TODO: determine locale here
        locales: {
            // 递归深合并
            // 如果遇到相同KEY的值是简单数据类型，后面会覆盖前面；如果值是对象则合并
            [enUSStr]: merge(commonLocales[enUSStr], locales[enUSStr]),
            [zhCNStr]: merge(commonLocales[zhCNStr], locales[zhCNStr]),
        },
        warningHandler: message => {
            if (!message.includes('tdk.')) {
                console.warn(message);
            }
        },
    });

    //moment

    return lang;
}
